import Vue from 'vue'
import App from './App.vue'
import router from './router'

import './assets/css/common.scss'

import api from './services/'
Vue.prototype.$api = api

import Toast from 'vue-easy-toast'
Vue.use(Toast)

import VueParticles from 'vue-particles'
Vue.use(VueParticles)

Vue.config.productionTip = false


//ant
import {
  Button, Input, Modal, InputNumber, Select, message, Form, Empty, Spin, Checkbox
} from 'ant-design-vue'

import 'ant-design-vue/dist/antd.css'

message.config({
  duration: 2,
  maxCount: 1,
  key: 1
})

Vue.prototype.$message = message;
Vue.prototype.$nzconfirm = function confirm(title, callback) {
  Modal.confirm({
    okText: '确认',
    cancelText: '取消',
    title: title,
    onOk: () => {
      return callback();
    }
  })
}

Vue.use(Button).use(Input).use(Modal).use(InputNumber).use(Select).use(Form).use(Empty).use(Spin).use(Checkbox);

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
